import { Injectable } from '@angular/core';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrderConnectionInformationVO } from '@project/components/article/model/vo/order-connection-information.vo';
import { ModelConversionService } from '@shared/convert/model-conversion.service';

@Injectable({providedIn: 'root'})
export class ArticleExportDataService {

  constructor(
    private modelConversionService: ModelConversionService,
    private wagoApiClient: WagoApiClient,
  ) {
  }

  public exportToDataCenter(args: { projectId: number, articleNumbers: string[] }): Observable<string> {
    return this.wagoApiClient.post<string>('article-export/datacenter', args, {responseType: 'text'});
  }

  public getAlternativeOrderNumber(retrieveAlternativeOrderNumbers: OrderConnectionInformationVO[]): Observable<OrderConnectionInformationVO[]> {
    return this.wagoApiClient.post<any[]>('article-export/retrievealternativeordernumbers', retrieveAlternativeOrderNumbers, null,
      {isErrorHandlingRequired: false}).pipe(map(response => this.modelConversionService.convertOrderConnectionInformationVOs(response)));
  }
}
